// extracted by mini-css-extract-plugin
export default {"searchInput":"search-input_searchInput__wzK0f","searchIconContainer":"search-input_searchIconContainer__7a3Jc","closeContainer":"search-input_closeContainer__u95X9"};